// ©2024 Austin App House. All rights reserved.
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Form, reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { toggleModal } from '../../../storage/actions/modalsActions';
import Notification from '../../notification';
import defaultInitialValues from '../../../utils/reduxForm/InitialValues/contractorTaxInformation';
import EntitySection from './section/contractorTaxInformation/entitySection';
import TINSection from './section/contractorTaxInformation/TINSection';
import CertificationSection from './section/contractorTaxInformation/CertificationSection';
import Electronic1099Section from './section/contractorTaxInformation/Electronic1099Section';

let ContractorTaxInformationReduxForm = ({
                                             handleSubmit,
                                             error,
                                             initialValues,
                                         }) => {
    useEffect(() => {
        if (error) Notification('error', { message: error });
    }, [error]);

    const preventSubmitOnEnter = (event) => {
        if (event.key === 'Enter') event.preventDefault();
    };

    return (
        <Form
            onSubmit={handleSubmit}
            onKeyPress={preventSubmitOnEnter}
            className="form_body"
        >
            <div className="form_section entity_type_section">
                <EntitySection />
            </div>

            <div className="form_section tin_section">
                <TINSection initialValues={initialValues} />
            </div>

            <div className="form_section certification_section">
                <CertificationSection />
            </div>

            <div className="form_section electronic_1099_section">
                <Electronic1099Section />
            </div>
        </Form>
    );
};

ContractorTaxInformationReduxForm = reduxForm({
    form: 'contractorTaxInformationReduxForm',
})(ContractorTaxInformationReduxForm);

const mapStateToProps = (state) => ({
    initialValues: state.profile?.taxInfo?.entityType
        ? state.profile?.taxInfo
        : defaultInitialValues,
});

export default connect(mapStateToProps, { toggleModal })(
    withRouter(ContractorTaxInformationReduxForm)
);
